export default __webpack_public_path__ + "static/media/AXIS-Bank.758c848d.webp";